/** Shared composites (`src/components/**` except payment): cards, favourites, price lines, support, sign-in. */
export const fr = {
  /* Vehicle card */
  'vehicle.open': 'Voir {name}, {total} pour {days}',
  'vehicle.deposit': 'Caution {amount}',
  'vehicle.freeDelivery': 'Livraison gratuite',
  'vehicle.perDay': '{price} / jour · {days}',
  /* Experience card */
  'experience.perPerson': '/ pers.',
  'experience.perVehicle': '/ véhicule',
  'experience.from': 'dès',
  'experience.open': '{title}, dès {price} {unit}',
  /* API-ACT-1: clients’ rating (hidden when none); no price when the server prices nothing. */
  'experience.openRated': {
    one: '{title}, dès {price} {unit}, noté {rating} sur 5 ({count} avis)',
    other: '{title}, dès {price} {unit}, noté {rating} sur 5 ({count} avis)',
  },
  'experience.openNoPrice': '{title}',
  'experience.openNoPriceRated': {
    one: '{title}, noté {rating} sur 5 ({count} avis)',
    other: '{title}, noté {rating} sur 5 ({count} avis)',
  },
  'experience.rating': '{rating} ({count})',
  /* Favourites */
  'favourite.add': 'Ajouter {name} aux favoris',
  'favourite.remove': 'Retirer {name} des favoris',
  'favourite.added': 'Ajouté aux favoris',
  'favourite.removed': 'Retiré des favoris',
  'favourite.signIn': 'Connectez-vous pour enregistrer vos favoris.',
  'favourite.error': 'Impossible de modifier vos favoris. Réessayez dans un instant.',
  /* Price lines */
  'price.loading': 'Calcul du prix',
  'price.estimate': 'Estimation',
  'price.estimateHint': 'Prix calculé avant connexion : le montant exact est confirmé à l’étape suivante.',
  /* Support links */
  'support.label': 'Contacter l’assistance',
  'support.call': 'Appeler le {phone}',
  'support.email': 'E-mail',
  'support.emailTo': 'E-mail : {email}',
  /* Google sign-in */
  'google.continue': 'Continuer avec Google',
  'google.busy': 'Connexion avec Google…',
} as const;
